import { render } from "./BoundStudentListDrawer.vue?vue&type=template&id=666f4cbe"
import script from "./BoundStudentListDrawer.vue?vue&type=script&lang=js"
export * from "./BoundStudentListDrawer.vue?vue&type=script&lang=js"

import "./BoundStudentListDrawer.vue?vue&type=style&index=0&id=666f4cbe&lang=css"

import exportComponent from "/voc/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__